import { Activity } from '@absg/api-inventory';
import { RequiredNote } from '@absg/nim-client-shared';

export class DispenseDetailSnapshotViewModel {
  dispenseDetailSnapshotId: number;
  transactionId?: number;
  supplierProductInclusionId?: number;
  transactionInventoryDetailID?: number;
  gcnSequenceNumber: string;
  genericName: string;
  displayName: string;
  dispenseUnitOfMeasureDisplay: string;
  dispenseUnitOfMeasureConversionFactor: number;
  inventoryUnitOfMeasureDisplay: string;
  inventoryUnitOfMeasureConversionFactor: number;
  volumeUnitOfMeasureDisplay: string;
  volumeUnitOfMeasureConversionFactor: number;
  purchaseUnitOfMeasureConversionFactor: number;
  infuseNotes1: string;
  infuseNotes2: string;
  infuseNotes3: string;
  dispenseTypeId: number;
  unitNdc: string;
  packageNdc: string;
  tradeName: string;
  isPracticeFavorite: boolean;
  isDiscontinued: boolean;
  is340B: boolean;
  isBuyIn: boolean;
  formularyTypeId: number;
  alternateName?: string;
  purchaseUnitOfMeasureDisplay?: string;
  dispenseTypeName?: string;
  itemId?: string;
  isRefrigerated?: boolean;
  lotNumber?: string;
  expirationDate?: Date;
  bundleLabelName?: string;
  bundleLabelCode?: string;
  positionName?: string;
  accessPointName?: string;
  autoPrintLabel?: boolean;
  requiredNotes?: RequiredNote;
  autoPrintReceipt?: boolean;
  productGroupTypeId?: number;
  displayInfusionNotesOnLabel?: boolean;
  displayInfusionNotesOnReceipt?: boolean;
  displayRequiredNoteOnLabel?: boolean;
  displayRequiredNoteOnReceipt?: boolean;
  isWitnessRequired?: boolean;
  instructions: string;
  displayInstructionsOnLabel: boolean;
  route: string;
  displayRouteOnLabel: boolean;
  displayFluidOnLabel?: boolean;
  displayDurationOnLabel?: boolean;
  isItem505b2: boolean;

  // for print
  activities?: Array<Activity>;
  lotNumbers?: Array<string>;
  wasteQtyAfterDispense?: number;
  wasteQtyAtDispense?: number;
  returnQtyAfterDispense?: number;
  returnQtyAtDispense?: number;
  fromCabinetQty?: number;
  fromUnderHoodQty?: number;
  outboundQty?: number;
  toCabinetQty?: number;
  totalDispenseQty?: number;
  toUnderHoodQty?: number;
  patientId?: number;
  patientOwnedItemTypeId?: number;
  patientOwnedPatientIdNumber?: string;
  patientOwnedPatientFirstName?: string;
  patientOwnedPatientLastName?: string;
  patientOwnedPatientDOB?: Date;
  patientOwnedItemTypeLongName?: string;
  patientOwnedItemTypeShortName?: string;
  inventoryItemId?: number;
  txnDetailIdList?: Array<number>;
}
